const types = {
  UNSIGNED_BYTE: 'UNSIGNED_BYTE',
  FLOAT: 'FLOAT',
  HALF_FLOAT: 'HALF_FLOAT',
  LINEAR: 'LINEAR',
  NEAREST: 'NEAREST',
};

export default types;
